import React from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import {
  authProtectedRoutes,
  publicRoutes,
  superadminRoutes,
} from "./allRoutes";
import AuthProtected from "./AuthProtected";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Public Routes */}
        <Route>
          {publicRoutes.map((route: any, idx: React.Key) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}
        </Route>

        {/* Superadmin Routes */}
        <Route>
          {superadminRoutes.map((route: any, idx: React.Key) => (
            <Route
              path={route.path}
              element={
                <AuthProtected
                  roles={route.roles}
                  menuCategory={route.menuCategory}
                >
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={`superadmin-${idx}`}
            />
          ))}
        </Route>

        {/* Auth Protected Routes */}
        <Route>
          {authProtectedRoutes.map((route: any, idx: React.Key) => (
            <Route
              path={route.path}
              element={
                <AuthProtected
                  roles={route.roles}
                  menuCategory={route.menuCategory}
                >
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={`protected-${idx}`}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
